import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import React from "react";
import { Button } from "react-bootstrap";
import { FaFileExcel } from "react-icons/fa";
import { HiDownload } from "react-icons/hi";
import {
  formatTotalRow,
  form24QFields,
  form26QFields,
  form27EQFields,
  formGSTR1Fields,
  formGSTR7Fields,
  getClientsEmployeeData,
} from "../utils/client/misc";

const ExportToExceljs = ({
  data,
  fileName,
  formName,
  clientName = "",
  clientTan = "",
  financialYear = "",
  month = "",
  selectedQuarter,
  buttonType = "",
}) => {
  const clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  const extractKeyValues = (arr, keyName) => {
    return arr.map((item) => item[keyName]);
  };

  const filterDataByKeys = (columns, data) => {
    const allowedKeys = columns.map((col) => col.key);
    console.log("allowkey", allowedKeys);

    return data.map((item) => {
      const filtered = {};
      allowedKeys.forEach((key) => {
        if (item.hasOwnProperty(key)) {
          filtered[key] = item[key];
        } else {
          filtered[key] = "";
        }
      });
      return filtered;
    });
  };

  const exportToExcel = async () => {
    //const frmName = formName === "genreport24q" ? "Form24Q" : formName;
    const frmName = formName;
    const workbook = new ExcelJS.Workbook();
    //let worksheet = workbook.addWorksheet("Sheet 1");
    let selMnFrEmpData = [];

    let headerAndKeyArray = "";
    if (formName === "form24q") {
      headerAndKeyArray = form24QFields;
    } else if (formName === "form26q") {
      headerAndKeyArray = form26QFields;
    } else if (formName === "form27eq") {
      headerAndKeyArray = form27EQFields;
    } else if (formName === "formgstr1") {
      headerAndKeyArray = formGSTR1Fields;
    } else if (formName === "formgstr7") {
      headerAndKeyArray = formGSTR7Fields;
    } else if (formName === "employeeData") {
      headerAndKeyArray = getClientsEmployeeData;
    }

    const headers = extractKeyValues(headerAndKeyArray, "label");

    if (formName !== "employeeData") {
      let worksheet = workbook.addWorksheet("Sheet 1");
      // ✅ 1. Insert client name row
      worksheet.mergeCells(1, 1, 1, 5);
      const clientNameCell = worksheet.getCell("A1");
      clientNameCell.value = `${clientName} (Tan: ${clientTan})`;
      clientNameCell.font = { bold: true, size: 14 };
      clientNameCell.alignment = { horizontal: "left", vertical: "middle" };
      worksheet.getRow(1).height = 25;

      worksheet.mergeCells(2, 1, 2, 5);
      const clientInfoCell = worksheet.getCell("A2");
      clientInfoCell.value = `FormName: ${frmName}, FinancialYear: ${financialYear}, Month: ${month}`;
      clientInfoCell.font = {
        bold: true,
        size: 12,
        color: { argb: "FFFF0000" },
      };
      clientInfoCell.alignment = { horizontal: "left", vertical: "middle" };
      worksheet.getRow(2).height = 20;

      //const headerRow = worksheet.getRow(formName === "employeeData" ? 8 : 3);
      const headerRow = worksheet.getRow(3);
      headers.forEach((header, index) => {
        const cell = headerRow.getCell(index + 1);

        // if (formName === "employeeData") {
        //   if (index === 3) {
        //     header = `${header} (${selMnFrEmpData[0].trim().toUpperCase()})`;
        //   }
        //   if (index === 6) {
        //     header = `${header} (${selMnFrEmpData[1].trim().toUpperCase()})`;
        //   }
        //   if (index === 9) {
        //     header = `${header} (${selMnFrEmpData[2].trim().toUpperCase()})`;
        //   }
        // }

        cell.value = header;
        cell.font = { bold: true, size: 9.5, color: { argb: "00000000" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "CCECFF" },
        };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true,
        };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };

        // Optional: set column width
        //worksheet.getColumn(index + 1).width = Math.max(header.length + 5, 25);
        worksheet.getColumn(index + 1).width = 15;
      });

      headerRow.height = 80;

      // ✅ 3. Add filtered data rows starting from row 3
      const newDataArray = filterDataByKeys(headerAndKeyArray, data);
      console.log("newDataArray", newDataArray);
      console.log("data", data);
      console.log("headerAndKeyArray", headerAndKeyArray);
      //let rowIndex = formName === "employeeData" ? 9 : 4;
      let rowIndex = 4;

      newDataArray.forEach((item, index) => {
        const row = worksheet.getRow(rowIndex++);
        Object.values(item).forEach((value, colIndex) => {
          const cell = row.getCell(colIndex + 1);
          // if (formName === "employeeData") {
          //   if (colIndex === 0) {
          //     cell.value = index + 1;
          //   } else {
          //     cell.value = value || "";
          //   }
          // } else {
          //   cell.value = value || "";
          // }
          cell.value = value || "";

          if (typeof value === "number" || !isNaN(value)) {
            if (cell.value === "") cell.value = "0.00";
            cell.alignment = { horizontal: "right", vertical: "middle" };
          } else {
            cell.alignment = { horizontal: "left", vertical: "middle" };
          }
          cell.font = { size: 9.5 };
        });
      });
    } else if (formName === "employeeData") {
      // selMnFrEmpData = month.split(",");

      // worksheet.mergeCells(1, 1, 1, 3);
      // const OrgName = worksheet.getCell("A1");
      // OrgName.value = "ORGANISATION NAME";
      // OrgName.font = { bold: true, size: 10 };
      // OrgName.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(1, 4, 1, 7);
      // const OrgNameValue = worksheet.getCell("D1");
      // OrgNameValue.value = clientInfo?.client?.cn;
      // OrgNameValue.font = { size: 11 };
      // OrgNameValue.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(2, 1, 2, 3);
      // const OrgAdd = worksheet.getCell("A2");
      // OrgAdd.value = "ORGANISATION ADDRESS WITH PINCODE";
      // OrgAdd.font = { bold: true, size: 10 };
      // OrgAdd.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(2, 4, 2, 7);
      // const OrgAddValue = worksheet.getCell("D2");
      // OrgAddValue.value = `${clientInfo?.client?.a1} - ${clientInfo?.client?.pi}`;
      // OrgAddValue.font = { size: 11 };
      // OrgAddValue.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(3, 1, 3, 3);
      // const OrgDeductPan = worksheet.getCell("A3");
      // OrgDeductPan.value = "ORGANISATION / DEDUCTOR - PAN";
      // OrgDeductPan.font = { bold: true, size: 10 };
      // OrgDeductPan.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(3, 4, 3, 7);
      // const OrgDeductPanValue = worksheet.getCell("D3");
      // OrgDeductPanValue.value = clientInfo?.client?.pa;
      // OrgDeductPanValue.font = { size: 11 };
      // OrgDeductPanValue.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(4, 1, 4, 3);
      // const DDOName = worksheet.getCell("A4");
      // DDOName.value = "D.D.O.NAME";
      // DDOName.font = { bold: true, size: 10 };
      // DDOName.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(4, 4, 4, 7);
      // const DDONameValue = worksheet.getCell("D4");
      // DDONameValue.value = clientInfo?.client?.dn;
      // DDONameValue.font = { size: 11 };
      // DDONameValue.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(5, 1, 5, 3);
      // const DDOPanNo = worksheet.getCell("A5");
      // DDOPanNo.value = "D.D.O.PAN NO";
      // DDOPanNo.font = { bold: true, size: 10 };
      // DDOPanNo.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(5, 4, 5, 7);
      // const DDOPanNoValue = worksheet.getCell("D5");
      // DDOPanNoValue.value = clientInfo?.client?.dp;
      // DDOPanNoValue.font = { size: 11 };
      // DDOPanNoValue.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(6, 1, 6, 3);
      // const DDODateOfBirth = worksheet.getCell("A6");
      // DDODateOfBirth.value = "D.D.O DATE OF BIRTH";
      // DDODateOfBirth.font = { bold: true, size: 10 };
      // DDODateOfBirth.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(6, 4, 6, 7);
      // const DDODateOfBirthValue = worksheet.getCell("D6");
      // DDODateOfBirthValue.value = clientInfo?.client?.ddb;
      // DDODateOfBirthValue.font = { size: 11 };
      // DDODateOfBirthValue.alignment = {
      //   horizontal: "left",
      //   vertical: "middle",
      // };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(7, 1, 7, 3);
      // const AuthPersonName = worksheet.getCell("A7");
      // AuthPersonName.value = "AUTHORISED PERSON NAME & FATHER'S NAME";
      // AuthPersonName.font = { bold: true, size: 10 };
      // AuthPersonName.alignment = { horizontal: "left", vertical: "middle" };
      // worksheet.getRow(1).height = 25;

      // worksheet.mergeCells(7, 4, 7, 7);
      // const AuthPersonNameValue = worksheet.getCell("D7");
      // AuthPersonNameValue.value = clientInfo?.client?.ap;
      // AuthPersonNameValue.font = { size: 11 };
      // AuthPersonNameValue.alignment = {
      //   horizontal: "left",
      //   vertical: "middle",
      // };
      // worksheet.getRow(1).height = 25;
      let newDataArray = [];
      let worksheet = "";
      console.log("employeeData", data);
      for (const clientObj of data) {
        // const { clientInfo, data: empData } = clientObj;
        const clientInfo = clientObj.data.client;
        const empData = clientObj.data.emp;

        // console.log("ssssss", clientInfo, data);
        // worksheet = workbook.addWorksheet(clientInfo.cn || "Client");
        let sheetName = clientInfo?.cn?.toString().trim() || "Client";

        // Excel sheet name limit = 31 chars
        sheetName = sheetName.substring(0, 28);

        // If duplicate name exists, append suffix
        let uniqueName = sheetName;
        let counter = 1;
        while (workbook.getWorksheet(uniqueName)) {
          uniqueName = `${sheetName}_${counter++}`;
        }

        worksheet = workbook.addWorksheet(uniqueName);

        const headerAndKeyArray = getClientsEmployeeData;
        const headers = extractKeyValues(headerAndKeyArray, "label");
        const selMnFrEmpData = month.split(",");

        // Write organization details
        worksheet.mergeCells(1, 1, 1, 3);
        worksheet.getCell("A1").value = "ORGANISATION NAME";
        worksheet.getCell("D1").value = clientInfo.cn;

        worksheet.mergeCells(2, 1, 2, 3);
        worksheet.getCell("A2").value = "ORGANISATION ADDRESS WITH PINCODE";
        worksheet.getCell("D2").value = `${clientInfo.a1} - ${clientInfo.pi}`;

        worksheet.mergeCells(3, 1, 3, 3);
        worksheet.getCell("A3").value = "ORGANISATION / DEDUCTOR - PAN";
        worksheet.getCell("D3").value = clientInfo.pa;

        worksheet.mergeCells(4, 1, 4, 3);
        worksheet.getCell("A4").value = "D.D.O.NAME";
        worksheet.getCell("D4").value = clientInfo.dn;

        worksheet.mergeCells(5, 1, 5, 3);
        worksheet.getCell("A5").value = "D.D.O.PAN NO";
        worksheet.getCell("D5").value = clientInfo.dp;

        worksheet.mergeCells(6, 1, 6, 3);
        worksheet.getCell("A6").value = "D.D.O DATE OF BIRTH";
        worksheet.getCell("D6").value = clientInfo.ddb;

        worksheet.mergeCells(7, 1, 7, 3);
        worksheet.getCell("A7").value =
          "AUTHORISED PERSON NAME & FATHER'S NAME";
        worksheet.getCell("D7").value = clientInfo.ap;

        // Headers
        const headerRow = worksheet.getRow(8);
        headers.forEach((header, index) => {
          if (index === 3)
            header = `${header} (${selMnFrEmpData[0].trim().toUpperCase()})`;
          if (index === 6)
            header = `${header} (${selMnFrEmpData[1].trim().toUpperCase()})`;
          if (index === 9)
            header = `${header} (${selMnFrEmpData[2].trim().toUpperCase()})`;
          const cell = headerRow.getCell(index + 1);

          cell.value = header;
          cell.font = { bold: true, size: 9.5, color: { argb: "00000000" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          worksheet.getColumn(index + 1).width = 15;
        });

        // Data Rows
        newDataArray = filterDataByKeys(headerAndKeyArray, empData);
        let rowIndex = 9;
        newDataArray.forEach((item, i) => {
          const row = worksheet.getRow(rowIndex++);
          Object.values(item).forEach((value, colIndex) => {
            const cell = row.getCell(colIndex + 1);

            if (colIndex === 0) {
              cell.value = i + 1;
            } else {
              cell.value = value || "";
            }

            if (typeof value === "number" || !isNaN(value)) {
              if (cell.value === "") cell.value = "0.00";
              cell.alignment = { horizontal: "right", vertical: "middle" };
            } else {
              cell.alignment = { horizontal: "left", vertical: "middle" };
            }
            cell.font = { size: 9.5 };
          });
        });
        //let rowIndex = 20;
        const row = worksheet.getRow(rowIndex++);
        formatTotalRow(row, "TOTAL", 2, true);

        //GROSS SALARY First Quarter Month
        const totalGt1 = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gt1?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalGt1, 4, true);

        //GROSS SALARY First Quarter Tax
        const totalIt1 = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.it1?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalIt1, 5, true);

        //GROSS SALARY Second Quarter Month
        const totalGt2 = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gt2?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalGt2, 7, true);

        //GROSS SALARY Second Quarter Tax
        const totalIt2 = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.it2?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalIt2, 8, true);

        //GROSS SALARY Third Quarter Month
        const totalGt3 = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gt3?.toString().trim()) || 0;
          return sum + num;
        }, 0);

        formatTotalRow(row, totalGt3, 10, true);
        //GROSS SALARY Third Quarter Tax
        const totalIt3 = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.it3?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalIt3, 11, true);
      }
    }

    // ✅ 2. Manually add header row (row 2)

    // ✅ 4. Save to file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <>
      {buttonType === "GenerateReport" ? (
        <Button
          className="btn-primary-submit-to-ca"
          onClick={exportToExcel}
          disabled={data.length <= 0}
        >
          Generate Report
        </Button>
      ) : (
        <Button
          size="sm"
          className="btn-primary-submit-to-ca"
          onClick={exportToExcel}
        >
          <HiDownload
            style={{
              marginRight: "2px",
              transform: "scale(1.2)",
              transformOrigin: "center",
            }}
          />
          Excel
        </Button>
      )}
    </>
  );
};
export default ExportToExceljs;
